import { cn } from '@/lib/utils';

// The model separates paragraphs with blank lines; older runs wrote one block and still render as one.
export const summaryParagraphs = (text: string) =>
  text
    .split(/\n\s*\n/)
    .map(p => p.trim())
    .filter(Boolean);

export function SummaryText({ text, className }: { text: string; className?: string }) {
  return (
    <div className={cn('flex flex-col', className)}>
      {summaryParagraphs(text).map((paragraph, i) => (
        <p key={i}>{paragraph}</p>
      ))}
    </div>
  );
}
